import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { Alert, Button, Divider, Spin } from "antd";
import { formatTimeRange } from "../../../../../swzutils/DateUtil";
import ShortfallValueWithIcon from "../ShortfallValueWithIcon";
import { TENANT_EDIT_ACTIVE_TAB_KEY_PARAM_NAME, TenantEditTabKeyEnum } from "../../tenants/edit/TenantEditForm";
const VehicleTimeSlotsWidget = (props, exportedRef) => {
    const [loading, setLoading] = useState(false);
    const [vehicleTimeSlots, setVehicleTimeSlots] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadTimeSlots();
    };
    const loadTimeSlots = () => {
        setLoading(true);
        setErrorMessage(null);
        axios.get(`/admin/v1/dashboard/vehicle-time-slots/${props.date}`)
            .then(response => {
            setVehicleTimeSlots(response.data);
        }).catch(error => {
            axiosErrorHandler(error, errorMessage => {
                setErrorMessage(errorMessage);
            });
        }).finally(() => {
            setLoading(false);
        });
    };
    const timeSlotGroups = vehicleTimeSlots?.timeSlotGroups;
    return (_jsx(Spin, { spinning: loading, children: _jsxs("div", { className: "widget", children: [errorMessage &&
                    _jsxs(_Fragment, { children: [_jsx(Alert, { type: "error", title: errorMessage, banner: true }), _jsxs("p", { children: [_jsx("br", {}), _jsx(Button, { href: `#/app/tenants/edit/${props.tenantId}?${TENANT_EDIT_ACTIVE_TAB_KEY_PARAM_NAME}=${TenantEditTabKeyEnum.TIME_SLOTS}`, children: "Change or Add Time Slots" })] })] }), timeSlotGroups && timeSlotGroups.length && timeSlotGroups.map((timeSlotGroup, index) => {
                    return (_jsxs("div", { children: [index > 0 && _jsx(Divider, {}), _jsx("h3", { children: timeSlotGroup.name }), _jsxs("table", { className: "data-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { align: "center", children: "Time" }), _jsx("th", { align: "center", children: "Deliveries" }), _jsx("th", { align: "center", children: "Delivery Shortfall" }), _jsx("th", { align: "center", children: "Vehicles" }), _jsx("th", { align: "center", children: "Vehicle Shortfall" })] }) }), _jsx("tbody", { children: timeSlotGroup.timeSlots.map(timeSlot => {
                                            let key = (timeSlot.startTime || '') + '-' + (timeSlot.endTime || '');
                                            return (_jsxs("tr", { children: [_jsx("td", { align: "center", children: formatTimeRange(timeSlot.startTime, timeSlot.endTime) }), _jsx("td", { align: "center", children: timeSlot.totalDeliveries }), _jsx("td", { align: "center", children: _jsx(ShortfallValueWithIcon, { shortfallValue: timeSlot.deliveryShortfall }) }), _jsx("td", { align: "center", children: timeSlot.vehiclesRequired }), _jsx("td", { align: "center", children: _jsx(ShortfallValueWithIcon, { shortfallValue: timeSlot.vehicleShortfall }) })] }, key));
                                        }) })] })] }, `timeslot-${index}`));
                })] }) }));
};
export default React.forwardRef(VehicleTimeSlotsWidget);
